import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, SaleOrderCustomerData, SaleOrderData } from './types'

export const selectSaleOrderCustomerListEvent = (state: RootState): Event =>
  state.SaleOrderCustomerReducer.listEvent

export const selectSaleOrderCustomerList = (state: RootState): ListData => state.SaleOrderCustomerReducer.list

export const selectSaleOrderCustomerActionEvent = (state: RootState): Event =>
  state.SaleOrderCustomerReducer.actionEvent

export const selectSaleOrderCustomerDetail = (state: RootState): SaleOrderCustomerData | undefined =>
  state.SaleOrderCustomerReducer.detail

export const selectSaleOrderCustomerDetailEvent = (state: RootState): Event =>
  state.SaleOrderCustomerReducer.detailEvent

export const selectAllSaleOrderCustomerList = (state: RootState): SaleOrderCustomerData[] =>
  state.SaleOrderCustomerReducer.allSaleOrderCustomer

export const selectSaleOrderlEvent = (state: RootState): Event =>
  state.SaleOrderCustomerReducer.saleOrderEvent

export const selectAllSaleOrderList = (state: RootState): SaleOrderData | undefined =>
  state.SaleOrderCustomerReducer.saleOrder
